import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../../common/ModelSave";
import { CancelButton, SaveButton } from "../../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import { Country } from "../../../../utils/apis/master/Master";
library.add(fas);

const ExpertAreaCreate = (props) => {
  const { postData, getData, Select2Data } = useContext(Context);
  const id = props.show;
  const [areas, setAreas] = useState([]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });


  const [data, setData] = useState();
  const getSellerData = async () => {
    const res = await getData(`/admin/expert/${id}`);
    setData(res.data);
  };

  useEffect(() => {
    getSellerData();
  }, [id]);

  const GetAllPickupArea = async () => {
    if (data?.Expert_Detail?.city_id) {
      const response = await getData(
        `/common/masters/all-area?city_id=${data?.Expert_Detail?.city_id || ""}`,
      );
      if (response?.success) {
        setAreas(await Select2Data(response?.data, "area_id"));
      }

    }
  };
  useEffect(() => {
    GetAllPickupArea();

  }, [data]);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();

      DataToSend.append(
        "pickup_areas",
        JSON.stringify(data.pickup_areas.map((option) => option.value)),
      );
      DataToSend.append(
        "drop_areas",
        JSON.stringify(data.drop_areas.map((option) => option.value)),
      );
      const response = await postData(`/admin/expert/area-detail/${props?.id}`, DataToSend);

      if (response?.success) {
        props.setChangeStatus(true)
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Expert Area
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={() => handleSubmit(onSubmit)}
            role="form"
          // className="stateclass"
          >
            <Row>
              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Pickup Area</Form.Label>
                    <Controller
                      name="pickup_areas" // name of the field
                      {...register("pickup_areas", {
                        required: "Select Pickup Area",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isMulti
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.pickup_areas
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={areas}
                        />
                      )}
                    />
                    {errors.pickup_areas && (
                      <span className="text-danger">
                        {errors.pickup_areas.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Drop Area</Form.Label>
                    <Controller
                      name="drop_areas" // name of the field
                      {...register("drop_areas", {
                        required: "Select Drop Area",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isMulti
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.drop_areas
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={areas}
                        />
                      )}
                    />
                    {errors.drop_areas && (
                      <span className="text-danger">
                        {errors.drop_areas.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default ExpertAreaCreate;
